export const theme = {
    primaryDark: '#0D0C1D',
    primaryLight: '#D8C3A5',
    primaryHover: '#8E8D8A',
    mobile: '576px',
  }
  